import { createAction } from '@reduxjs/toolkit';

const saveVehicleFormValues = createAction(
  'ui/sealink/ferryFlow/saveVehicleFormValues'
);

export { saveVehicleFormValues };
